export const RESOURCE_TILE_HEIGHT = 84;

export const EXTRA_CONTENT_HEIGHT = 129;
